import React from "react";
import AppHeader from "../../../components/header";
import LegacyBroadband from "./LegacyBroadband";
import DigitalBroadband from "./DigitalBroadband";
import { Stack } from "@mui/material";

const BroadbandInfoPage = () => {
  return (
    <AppHeader>
      <Stack gap={4}>
        <LegacyBroadband />
        <DigitalBroadband />
      </Stack>
    </AppHeader>
  );
};

export default BroadbandInfoPage;
